


















































































import AnalyticsDateRangeSelectorDialog from "@/components/analytics/AnalyticsDateRangeSelectorDialog.vue";
import { BatchTypeEnum } from "@/lib/enum/batch-type.enum";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { handleError } from "@/lib/utility/handleError";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { MrfiktivPageFilterElementGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ThgPageFilterElementGen, ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import { ThgStatusEnum } from "@/store/enum/thg/thg-status.enum";
import { IPaginationFilterListElement } from "@/store/modules/base-pagination.store";
import { MeterReadingPaginatedModule } from "@/store/modules/meter-reading-paginated.store";
import { ThgPaginationModule } from "@/store/modules/thg-pagination.store";
import { TranslateResult } from "vue-i18n";
import { Component, Prop } from "vue-property-decorator";
import FilterCardPagination from "../filter/FilterCardPagination.vue";

@Component({
  components: { AnalyticsDateRangeSelectorDialog, FilterCardPagination }
})
export default class ThgBatchSelectDialog extends DarkModeHighlightMixin {
  @Prop()
  type!: BatchTypeEnum;

  @Prop({ default: false })
  typeLock?: boolean;

  @Prop({ default: true })
  autoSetFiler?: boolean;

  get types() {
    return Object.values(BatchTypeEnum);
  }

  get dateOptions() {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric"
    };
    return options;
  }

  get currentType() {
    return this.type;
  }
  set currentType(type: BatchTypeEnum) {
    this.selectedThg = [];
    this.$emit("update:type", type);
  }

  get isChargingStation() {
    return this.currentType === BatchTypeEnum.meterReading;
  }

  get isVehicle() {
    return this.currentType === BatchTypeEnum.vehicle;
  }

  get paginationFilterList(): IPaginationFilterListElement[] {
    if (this.isVehicle) {
      return ThgPaginationModule.filterList;
    }
    return MeterReadingPaginatedModule.filterList;
  }

  get paginationFilter(): ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[] {
    if (this.isVehicle) {
      return ThgPaginationModule.filter;
    }
    return MeterReadingPaginatedModule.filter;
  }

  set paginationFilter(filter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[]) {
    if (this.isVehicle) {
      ThgPaginationModule.setFilter(filter);
    } else {
      MeterReadingPaginatedModule.setFilter(filter);
    }
  }

  selectedThg: ThgThgViewModelGen[] = [];
  dialog = false;

  isLoading = false;

  search = "";

  get headers() {
    const headers: { text: string | TranslateResult; value: string; filter?: (value: any) => boolean }[] = [
      {
        text: this.$t("components.thg.ThgChargingStationMeterReadingTable.created"),
        value: "timestamp.created"
      },
      { text: "ID", value: "id" },
      { text: "UserID", value: "userId" },
      { text: "PartnerID", value: "partnerId" }
    ];

    if (this.isVehicle) {
      headers.push(
        { text: this.$t("components.thg.ThgBatchSelectDialog.numberplate"), value: "numberplate" },
        {
          text: this.$t("components.thg.ThgBatchSelectDialog.identificationnumber"),
          value: "registration.identificationnumber"
        },
        { text: this.$t("components.thg.ThgBatchSelectDialog.name"), value: "registration.name" }
      );
    }

    headers.push(
      {
        text: this.$t("components.thg.ThgBatchSelectDialog.countryCode"),
        value: "countryCode"
      },
      {
        text: this.$t("components.thg.ThgBatchSelectDialog.year"),
        value: "year"
      }
    );

    headers.push({ text: this.$t("components.thg.ThgBatchSelectDialog.status"), value: "status" });

    return headers;
  }

  get disabled() {
    return !this.selectedThg.length;
  }

  get loading() {
    return this.isLoading;
  }

  get allThgsToBatch() {
    if (this.isChargingStation) {
      return MeterReadingPaginatedModule.paginationList;
    } else {
      return ThgPaginationModule.paginationList;
    }
  }

  async getItems() {
    if (this.isChargingStation) {
      await this.filterMeterReadings();
    } else {
      await this.filterVehicles();
    }
  }

  async filterVehicles() {
    try {
      this.isLoading = true;
      await ThgPaginationModule.fetchAllFromBeginning({});
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  async filterMeterReadings() {
    try {
      this.isLoading = true;
      await MeterReadingPaginatedModule.fetchAllFromBeginning({});
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  emitSelected() {
    this.$emit("select", this.selectedThg);
    this.dialog = false;
  }

  initialize() {
    this.selectedThg = [];

    if (this.autoSetFiler) {
      const filter: ThgPageFilterElementGen[] = [
        {
          key: "status",
          operation: "$eq",
          value: ThgStatusEnum.CONFIRMED
        },
        {
          key: "countryCode",
          operation: "$eq",
          value: CountryCodeEnum.germany
        },
        {
          key: "year",
          operation: "$eq",
          value: "2023"
        }
      ];
      ThgPaginationModule.setFilter(filter);
      ThgPaginationModule.setIsLoadAll(true);
      MeterReadingPaginatedModule.setFilter(filter);
      MeterReadingPaginatedModule.setIsLoadAll(true);
    }
  }

  /**
   * closes the dialog
   */
  close() {
    this.dialog = false;
  }
}
